/* GLOBAL STATE PROVIDER */

import React, { createContext, useContext, useState, useEffect } from 'react';
import { machineLearningModelTrainAvgValueAPI } from '../api/api_definitions.js';

const GlobalStateContext = createContext();
export const useGlobalState = () => useContext(GlobalStateContext);

export const GlobalStateProvider = ({ children }) => {

  // ==========================================================
  // ANALISI-MACCHINE-CONNESSE VARIABLE - ALLARMI
  // ==========================================================
  const [machineFamilyConnected, setMachineFamilyConnected] = useState(0);
  const [infoMachineConnected, setInfoMachineConnected] = useState(null);
  const [tableMachineConnected, setTableMachineConnected] = useState(null);

  const [machineFamilyConnectedMDC, setMachineFamilyConnectedMDC] = useState(0);
  const [infoMachineConnectedMDC, setInfoMachineConnectedMDC] = useState(null);
  const [tableMachineConnectedMDC, setTableMachineConnectedMDC] = useState(null);

  const [machineFamilyConnectedTrigger, setMachineFamilyConnectedTrigger] = useState(0);
  const [infoMachineConnectedTrigger, setInfoMachineConnectedTrigger] = useState(null);
  const [tableMachineConnectedTrigger, setTableMachineConnectedTrigger] = useState(null);

  // ==========================================================
  // ANALISI-OVERVIEW-MACHINE-LEARNING VARIABLE
  // ==========================================================
  const [machineFamilyML, setMachineFamilyML] = useState(0);
  const [infoMachineStatusML, setInfoMachineStatusML] = useState(null);
  const [tableMachineStatusML, setTableMachineStatusML] = useState(null);
  const [tableMachineStatusThresholds, setTableMachineStatusThresholds] = useState(null);

  // ==========================================================
  // ANALISI-ERRORE-DRIVER VARIABLE
  // ==========================================================
  const [machineFamily, setMachineFamily] = useState(0);
  const [listCustomerMachines, setListCustomerMachines] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [listSNMachines, setListSNMachines] = useState([]);
  const [snMachine, setSnMachine] = useState("");

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const [plotData, setPlotData] = useState([]);
  const [plotDataInfo, setPlotDataInfo] = useState([]);

  // ==========================================================
  // ANALISI-ERRORE-STATISTICA — VERSIONE MULTI-BLOCCO
  // ==========================================================
  const emptyStatsBlock = {
    machineFamily: 0,
    listCustomerMachines: [],
    customerName: "",
    listSNMachines: [],
    snMachine: ""
  };

  const [statsBlocks, setStatsBlocks] = useState([ { ...emptyStatsBlock } ]);

  // Aggiunge un nuovo blocco
  const addStatsBlock = () => {
    setStatsBlocks(prev => [...prev, { ...emptyStatsBlock }]);
  };

  // Aggiorna un campo di un blocco specifico
  const updateStatsBlock = (index, field, value) => {
    setStatsBlocks(prev => {
      const updated = [...prev];
      updated[index][field] = value;

      // Reset dipendenze
      if (field === "machineFamily") {
        updated[index].customerName = "";
        updated[index].listCustomerMachines = [];
        updated[index].listSNMachines = [];
        updated[index].snMachine = "";
      }

      if (field === "customerName") {
        updated[index].listSNMachines = [];
        updated[index].snMachine = "";
      }

      return updated;
    });
  };

  // Rimuove un blocco
  const removeStatsBlock = (index) => {
    setStatsBlocks(prev => prev.filter((_, i) => i !== index));
  };

  // Time range comune
  const [dateRangeStats, setDateRangeStats] = useState([null, null]);
  const [startDateStats, endDateStats] = dateRangeStats;

  // ==========================================================
  // CODICI ALLARME
  // ==========================================================
  const [alarmCodes, setAlarmCodes] = useState([]);

  const addAlarmCode = (code) => {
    if (code && !alarmCodes.includes(code)) {
      setAlarmCodes(prev => [...prev, code]);
    }
  };

  const removeAlarmCode = (code) => {
    setAlarmCodes(prev => prev.filter(c => c !== code));
  };

  // ==========================================================
  // ALTRI STATI
  // ==========================================================
  // Analisi sensori
  const [machineFamilySensors, setMachineFamilySensors] = useState(0);
  const [infoSensors, setInfoSensors] = useState(null);
  const [tableSensors, setTableSensors] = useState(null);
  const [selectedSensors, setSelectedSensors] = useState(null);

  // Analisi produzione
  const [machineFamilyProduction, setMachineFamilyProduction] = useState(0);
  const [headTypeProduction, setHeadTypeProduction] = useState("0");
  const [minLaserPowerProduction, setMinLaserPowerProduction] = useState(0);
  const [maxLaserPowerProduction, setMaxLaserPowerProduction] = useState(15000);
  const [dateRangeProduction, setDateRangeProduction] = useState([new Date("2024/01/01"), new Date()]);
  const [startDateProduction, endDateProduction] = dateRangeProduction;
  const [infoPlotProduction, setInfoPlotProduction] = useState(null);

  // ANALISI-PRODUZIONE-CLIENTE
  const [machineFamilyProductionCustomer, setMachineFamilyProductionCustomer] = useState(0)

  const [listCustomerProductionCustomer, setListCustomerProductionCustomer] = useState([]);
  const [customerNameProductionCustomer, setCustomerNameProductionCustomer] = useState("");

  const [listSNMachinesProductionCustomer, setListSNMachinesProductionCustomer] = useState([]);
  const [snMachineProductionCustomer, setSnMachineProductionCustomer] = useState("");

  const [dateRangeProductionCustomer, setDateRangeProductionCustomer] = useState([null, null]);
  const [startDateProductionCustomer, endDateProductionCustomer] = dateRangeProductionCustomer;

  const [infoPlotProductionCustomer, setInfoPlotProductionCustomer] = useState(null)


  // ANALISI-TEMPO-VETRINO-CLIENTE
  const [machineFamilyGlassTimeCustomer, setMachineFamilyGlassTimeCustomer] = useState(0)

  const [listCustomerGlassTimeCustomer, setListCustomerGlassTimeCustomer] = useState([]);
  const [customerNameGlassTimeCustomer, setCustomerNameGlassTimeCustomer] = useState("");

  const [listSNMachinesGlassTimeCustomer, setListSNMachinesGlassTimeCustomer] = useState([]);
  const [snMachineGlassTimeCustomer, setSnMachineGlassTimeCustomer] = useState("");

  const [dateRangeGlassTimeCustomer, setDateRangeGlassTimeCustomer] = useState([null, null]);
  const [startDateGlassTimeCustomer, endDateGlassTimeCustomer] = dateRangeGlassTimeCustomer;

  const [infoGlassTimeCustomer, setInfoGlassTimeCustomer] = useState(null)
  const [tableGlassTimeCustomer, setTableGlassTimeCustomer] = useState(null)


  // ANALISI-OVERVIEW-CLIENTE
  const [infoConnectionMachineCustomerID, setInfoConnectionMachineCustomerID]   = useState(null);
  const [tableConnectionMachineCustomerID, setTableConnectionMachineCustomerID] = useState(null);
  const [tableStatusMachineCustomerID, setTableStatusMachineCustomerID] = useState(null);


  // ==========================================================
  // API GATEWAY RESPONSE MANAGEMENT
  // ==========================================================
  useEffect(() => {
    machineLearningModelTrainAvgValueAPI()
      .then((dataAPI) => {
        if (dataAPI !== null) {
          const parsedData = JSON.parse(dataAPI.DF);
          const categories = Object.keys(parsedData);
          const valuesLabel0 = Object.values(parsedData).map(item => Object.values(item)[0]);
          const valuesLabel1 = Object.values(parsedData).map(item => Object.values(item)[1]);

          setPlotData([
            { x: categories, y: valuesLabel0, type: 'bar', name: 'Critico - media dati modello ML', marker: { color: '#880808', width: 1 } },
            { x: categories, y: valuesLabel1, type: 'bar', name: 'Buono - media dati modello ML', marker: { color: '#008000', width: 1 } }
          ]);
        }
      })
      .catch(console.log);
  }, []);

  // ==========================================================
  // RENDER PROVIDER
  // ==========================================================
  return (
    <GlobalStateContext.Provider
      value={{
        statsBlocks, setStatsBlocks,
        addStatsBlock,
        updateStatsBlock,
        removeStatsBlock,
        dateRangeStats, setDateRangeStats,
        startDateStats, endDateStats,
        alarmCodes, setAlarmCodes, addAlarmCode, removeAlarmCode,

        machineFamilyConnected, setMachineFamilyConnected,
        infoMachineConnected, setInfoMachineConnected,
        tableMachineConnected, setTableMachineConnected,
        machineFamilyConnectedMDC, setMachineFamilyConnectedMDC,
        infoMachineConnectedMDC, setInfoMachineConnectedMDC,
        tableMachineConnectedMDC, setTableMachineConnectedMDC,
        machineFamilyConnectedTrigger, setMachineFamilyConnectedTrigger,
        infoMachineConnectedTrigger, setInfoMachineConnectedTrigger,
        tableMachineConnectedTrigger, setTableMachineConnectedTrigger,
        machineFamilyML, setMachineFamilyML,
        infoMachineStatusML, setInfoMachineStatusML,
        tableMachineStatusML, setTableMachineStatusML,
        tableMachineStatusThresholds, setTableMachineStatusThresholds,
        machineFamily, setMachineFamily,
        listCustomerMachines, setListCustomerMachines,
        customerName, setCustomerName,
        listSNMachines, setListSNMachines,
        snMachine, setSnMachine,
        dateRange, setDateRange,
        startDate, endDate,
        plotData, setPlotData,
        plotDataInfo, setPlotDataInfo,
        machineFamilySensors, setMachineFamilySensors,
        infoSensors, setInfoSensors,
        tableSensors, setTableSensors,
        selectedSensors, setSelectedSensors,
        machineFamilyProduction, setMachineFamilyProduction,
        headTypeProduction, setHeadTypeProduction,
        minLaserPowerProduction, setMinLaserPowerProduction,
        maxLaserPowerProduction, setMaxLaserPowerProduction,
        dateRangeProduction, setDateRangeProduction,
        startDateProduction, endDateProduction,
        infoPlotProduction, setInfoPlotProduction,
        machineFamilyProductionCustomer, setMachineFamilyProductionCustomer,
        listCustomerProductionCustomer, setListCustomerProductionCustomer,
        customerNameProductionCustomer, setCustomerNameProductionCustomer,
        listSNMachinesProductionCustomer, setListSNMachinesProductionCustomer,
        snMachineProductionCustomer, setSnMachineProductionCustomer,
        dateRangeProductionCustomer, setDateRangeProductionCustomer,
        startDateProductionCustomer, endDateProductionCustomer,
        infoPlotProductionCustomer, setInfoPlotProductionCustomer,
        machineFamilyGlassTimeCustomer, setMachineFamilyGlassTimeCustomer,
        listCustomerGlassTimeCustomer, setListCustomerGlassTimeCustomer,
        customerNameGlassTimeCustomer, setCustomerNameGlassTimeCustomer,
        listSNMachinesGlassTimeCustomer, setListSNMachinesGlassTimeCustomer,
        snMachineGlassTimeCustomer, setSnMachineGlassTimeCustomer,
        dateRangeGlassTimeCustomer, setDateRangeGlassTimeCustomer,
        startDateGlassTimeCustomer, endDateGlassTimeCustomer,
        infoGlassTimeCustomer, setInfoGlassTimeCustomer,
        tableGlassTimeCustomer, setTableGlassTimeCustomer,
        infoConnectionMachineCustomerID, setInfoConnectionMachineCustomerID,
        tableConnectionMachineCustomerID, setTableConnectionMachineCustomerID,
        tableStatusMachineCustomerID, setTableStatusMachineCustomerID
        
      }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};
